import React from "react";
//#region types
import { TranslationKeys } from "translations";
//#endregion
//#region components
import { AddSupportCaseLink } from "components/support";
//#endregion
import { LocalizationHelperInstance } from "utils/helpers";

// Description shown under the VAT field when the company is not registered for VAT ("Ej momsregistrerad").
// Same idiom as the locked company name / org number fields in company settings: explanation + support link.
const NotVatRegisteredVatDescription: React.FC = () => (
  <>
    {LocalizationHelperInstance.getFormattedMessage(TranslationKeys.Article.VatDescriptionNotVatRegistered)}{" "}
    <AddSupportCaseLink />{" "}
    {LocalizationHelperInstance.getFormattedMessage(
      TranslationKeys.Article.VatDescriptionNotVatRegisteredContactSupport
    )}
  </>
);

export default NotVatRegisteredVatDescription;
